<template>
	<div class="mb-4">
		<h2>{{ $t('unsubscribe') }}</h2>
		<p>{{ $t('unsubscribe-more') }}</p>
		<div v-for="(subscription,index) in subscriptions" :key="index" class="custom-control custom-checkbox">
			<input type="checkbox" class="custom-control-input" :id="'checkbox-' + subscription.id" :value="subscription.id" v-model="checked_subs">
			<label class="custom-control-label" :for="'checkbox-' + subscription.id">{{ subscription.value }}</label>
		</div>
		<button v-if="subscriptions.length > 1" class="m-2 btn btn-sm btn-secondary" @click="select_all">{{ $t('select-all') }}</button>
		<button v-if="subscriptions.length > 1" class="m-2 btn btn-sm btn-secondary" @click="select_none">{{ $t('select-none') }}</button>
		<div v-if="unsubscribed" class="alert alert-success mt-4 mb-2" role="alert">
			{{ $t('success-unsubscribe') }}
		</div>
		<div class="row">
			<div class="col">
				<button class="m-2 btn btn-lg btn-primary" :disabled="checked_subs.length === 0" @click="unsubscribe">{{ $t('unsubscribe-notifications') }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

	export default {
		data() {
			return {
				subscribed_values: [],
				parameters: [],
				checked_subs: [],
				unsubscribed: false,
			}
		},

        created() {
			this.list();
		},

		watch: {
			checked_subs() {
				this.unsubscribed = false;
			}
		},

		methods: {
			select_all() {
                this.checked_subs = this.subscriptions.map(sub => sub.id);
			},

			select_none() {
				this.checked_subs = [];
			},

			async list() {
				const url = this.$NOTIFICATION_API + "/api/list/" + this.$route.params.id + '/' + this.$route.params.token;
                const results = await axios.get(url);
                this.parameters = results.data;
				this.select_all();
			},

			async unsubscribe() {
				const promises = this.checked_subs.map(async id => {
					const url = this.$NOTIFICATION_API + "/api/unsubscribe/" + id + '/' + this.$route.params.token;
					const results = await axios.get(url);
					return results.data;
				})
				this.subscribed_values = await Promise.all(promises);
				if (this.subscribed_values.length) {
					this.unsubscribed = true;
					this.parameters = this.parameters.filter(param => {
						const idx = this.subscribed_values.findIndex(sub => {
							return sub.id === param.id;
						})
						return (idx === -1);
					})
				}
			},
		},

		computed: {
            subscriptions() {
				return this.parameters.map(param => {
                    var val = '';
					if (param.type === 'ward') {
						val = this.$t('ward') + ' ' + param.val;
					} else if (param.type === 'neighbourhood') {
						val = this.$t('neighbourhood') + ' ' + param.val;
					} else if (param.type === 'location') {
						val = this.$t('location-desc',{ address: param.val, radius: param.radius});
					} else if (param.type === 'all') {
						val = this.$t('notices');
					} else {
						val = this.$t('unknown-type');
					}
					return {
						id: param.id,
						value: val
					}
				})
                //alert(this.parameters);
                //return [{ id: 1, value: "jianwang" }, { id: 2, value: "wangjian" }];
                //return this.parameters;
			}
		}

	}
</script>

<style>

</style>